import gql from 'graphql-tag';
import apollo from 'src/features/apolloSecure';

function checkUserUniquenessUccePeripheral(uccePeripheralId) {
  return apollo.client.query({
    variables: {
      uccePeripheralId,
    },
    query: gql`
        query User($uccePeripheralId: String!) {
          checkUserUniquenessUccePeripheral(uccePeripheralId: $uccePeripheralId) {
            firstName
            lastName
            used
            id
          }
        }
    `,
    fetchPolicy: 'network-only',
  }).then((res) => res.data.checkUserUniquenessUccePeripheral);
}

export default checkUserUniquenessUccePeripheral;
